import React from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import Spinner from '@cdo/apps/code-studio/pd/components/spinner';
import { projectUpdatedStatuses } from '@cdo/apps/code-studio/projectRedux';
var commonI18n = require('@cdo/locale');
var moduleStyles = require('./save-status.module.scss').default;
/**
 * Displays the project save status: a "Saving..." message with a spinner if saving,
 * an error message if there was a save error, or nothing if saving was successful.
 * Used on pages where the standard project header is not available.
 */
var SaveStatus = function () {
    var updatedStatus = useSelector(function (state) {
        return state.project.projectUpdatedStatus;
    });
    return (React.createElement("div", { className: moduleStyles.saveMessageContainer },
        React.createElement("div", { className: classNames(moduleStyles.saveMessage, moduleStyles.saveMessageSaving, updatedStatus === projectUpdatedStatuses.saving &&
                moduleStyles.saveMessageShow) },
            React.createElement(Spinner, { size: 'small' }),
            React.createElement("div", { className: moduleStyles.saveMessageText }, commonI18n.saving())),
        React.createElement("div", { className: classNames(moduleStyles.saveMessage, moduleStyles.saveMessageError, updatedStatus === projectUpdatedStatuses.error &&
                moduleStyles.saveMessageShow) },
            React.createElement("div", { className: moduleStyles.saveMessageText }, commonI18n.projectSaveError()))));
};
export default SaveStatus;
